import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormFieldBaseComponent } from '../form-field-base/form-field-base.component';
import { TextAlign } from 'chart.js';
import { FormFieldButtons } from '../form-field-buttons/form-field-buttons.component';
import { Style } from '@app/core/services/core-component.service';
import { FormButton } from '../form-field-button/form-field-button.component';
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'tt-input-email',
    templateUrl: './input-email.component.html',
    styleUrls: ['./input-email.component.css'],
})
export class InputEmailComponent extends FormFieldBaseComponent implements OnChanges, FormFieldButtons {
    override ttLabel: string = 'email';

    /**
     * The model of the input field.
     */
    @Input()
    ttModel: string = '';

    /**
     * Event emitted when the model value changes from the component, $event is the new ttModel value.
     */
    @Output()
    ttModelChange = new EventEmitter<string>();

    /**
     * If true = hide then hide visibility button.
     */
    @Input()
    get ttHideToggleButton(): boolean {
        return this._hideToggleButton;
    }
    set ttHideToggleButton(value: BooleanInput) {
        this._hideToggleButton = coerceBooleanProperty(value);
    }
    private _hideToggleButton: boolean = false;

    /**
     * The text align for the form-field.
     */
    @Input()
    ttTextAlign?: TextAlign;

    @Input()
    ttButtons?: FormButton[] | undefined;

    @Input()
    ttButtonParms?: { [key: string]: any } | undefined;

    /**
     * Event emitted when the search input-field loses focus.
     */
    @Output()
    ttOnBlur = new EventEmitter<string>();

    /**
     * Whether to display a generic clear button next to the form field.
     *
     * @emits ttModelChange with an empty string.
     * @default false
     */
    @Input()
    public get ttShowClearButton(): boolean {
        return this._showClearButton;
    }
    public set ttShowClearButton(value: BooleanInput) {
        this._showClearButton = coerceBooleanProperty(value);
    }
    private _showClearButton = false;

    /**
     * Whether to display a generic phone button next to the form field.
     *
     * @default true
     */
    @Input()
    public get ttShowEmailButton(): boolean {
        return this._showEmailButton;
    }
    public set ttShowEmailButton(value: BooleanInput) {
        this._showEmailButton = coerceBooleanProperty(value);
    }
    private _showEmailButton = true;

    /**
     * Reference to the base component.
     */
    @ViewChild('baseRef')
    baseRef?: FormFieldBaseComponent;

    /**
     * Reference to the input element.
     */
    @ViewChild('inputRef')
    inputRef?: ElementRef;

    /**
     * Emits `ttModelChanged` when theres a new value for `ttModel`.
     *
     * @param event the new value of `ttModel`
     */
    onModelChanged(event: string) {
        this.ttModelChange.emit(event);
    }

    /**
     * Id of elements in the component.
     */
    id = {
        input: crypto.randomUUID(),
    };

    public override style: Style = {
        input: {},
    };

    public override setStyle(ttStyle = this.ttStyle) {
        this.style = this.coreComponentService.setStyle({ style: this.style, ttStyle: ttStyle ?? {}, textAlign: this.ttTextAlign, mainElement: 'input' });
    }

    public onFocus() {
        setTimeout(() => {
            this.inputRef?.nativeElement.select();

            setTimeout(() => this.inputRef?.nativeElement.scrollIntoViewIfNeeded(), 50);
        });
    }

    public clearInput() {
        this.ttModel = '';
        this.onModelChanged(this.ttModel);
    }

    public openEmail() {
        window.open(`mailto:${this.ttModel}`, '_self');
    }

    /**
     * Emits the `ttOnBlur` event when the input field loses focus.
     *
     * @param _ unused focus event.
     */
    public onBlur(_: FocusEvent) {
        this.ttOnBlur.emit(this.ttModel);
    }

    override async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (!!changes['ttShowClearButton']) {
            this.ttShowClearButton = changes['ttShowClearButton'].currentValue;
        }

        if (!!changes['ttShowEmailButton']) {
            this.ttShowEmailButton = changes['ttShowEmailButton'].currentValue;
        }
    }
}
